import initialState from './initialState'
const SET_UNIQUE_KEY = function(state, payload) {
    state.uniqueKey = payload
}

const SET_PERMISSION = function(state, payload) {
    state.permission = payload
}

const RESET = function(state){
    console.log('reseteando UniqueKeyModule')
    Object.assign(state, initialState())
}

export default {
    SET_UNIQUE_KEY,
    SET_PERMISSION,
    RESET
}
